import { Component, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MenuService } from '../../../menu.service';

@Component({
    selector: 'ldw-info-bottom-sheet',
    templateUrl: './info-bottom-sheet.component.html',
    styleUrls: ['./info-bottom-sheet.component.css'],
    standalone: false
})
export class InfoBottomSheetComponent {
  private _bottomSheetRef = inject<MatBottomSheetRef<InfoBottomSheetComponent>>(MatBottomSheetRef);
  menuService = inject(MenuService);

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
